import { render, staticRenderFns } from "./CommentsTab.vue?vue&type=template&id=432ca7cf&scoped=true"
import script from "./CommentsTab.vue?vue&type=script&lang=js"
export * from "./CommentsTab.vue?vue&type=script&lang=js"
import style0 from "./CommentsTab.vue?vue&type=style&index=0&id=432ca7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ca7cf",
  null
  
)

export default component.exports